var r=(r,e,o,s,$)=>[e&&`${r}-helper`,o&&`${r}-error`,s&&`${r}-success`,$&&`${r}-info`].filter((r=>r)).join(" ");export{r as c};
